const ACTION_TYPES = {
  OPEN_SIDEBAR_MENU: 'OPEN_SIDEBAR_MENU',
  CLOSE_SIDEBAR_MENU: 'CLOSE_SIDEBAR_MENU'
}

export default ACTION_TYPES
